<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <!--<li>
            <a href=""> Blog </a>
          </li>
          <li>
              <a href=""> Licenses </a>
          </li>-->
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }} {{ WhiteLabellingTitle() }}<span v-if="host == 'b2b.novaemm.com' || host == 'localhost:8080'" >, powered by @tabnova</span>
      </div>
    </div>
  </footer>
  
</template>
<script>
export default {
  data() {
    return {
      host: window.location.host,
    };
  },
};
</script>
<style></style>
